import { XIFIN_PORTAL_URLS } from '../constants';

export const getXifinPortalUrl = (theme) => (XIFIN_PORTAL_URLS[theme] || XIFIN_PORTAL_URLS.myriad);
